import { render, staticRenderFns } from "./MapPosicao.vue?vue&type=template&id=5315931c"
import script from "./MapPosicao.vue?vue&type=script&lang=js"
export * from "./MapPosicao.vue?vue&type=script&lang=js"
import style0 from "./MapPosicao.vue?vue&type=style&index=0&id=5315931c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports